import { render, staticRenderFns } from "./IoTDataSimulator.component.vue?vue&type=template&id=0826a53f"
import script from "./IoTDataSimulator.component.ts?vue&type=script&lang=js&external"
export * from "./IoTDataSimulator.component.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0826a53f')) {
      api.createRecord('0826a53f', component.options)
    } else {
      api.reload('0826a53f', component.options)
    }
    module.hot.accept("./IoTDataSimulator.component.vue?vue&type=template&id=0826a53f", function () {
      api.rerender('0826a53f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/iot-simulator/IoTDataSimulator.component.vue"
export default component.exports